import { render } from "./SkipOnboardingModal.vue?vue&type=template&id=466e1f71"
import script from "./SkipOnboardingModal.vue?vue&type=script&lang=js"
export * from "./SkipOnboardingModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__